/**
 * Coin utility functions for balance calculations and formatting
 */

/**
 * Calculates total coin balances from balance array
 * @param {Array} balances - Array of balance objects from API
 * @returns {Object} Object containing individualCoins, organizationalCoins, totalCoins, and coinsSent
 */
export const calculateCoinTotals = (balances) => {
  let individual = 0;
  let organizational = 0;
  let totalCoinsSent = 0;

  balances.forEach(balance => {
    const received = (balance.coins_received_from_individuals || 0) +
                    (balance.coins_received_from_organizations || 0);
    const sent = balance.coins_sent || 0;

    totalCoinsSent += sent;

    // Count total coins received (not net balance)
    if (balance.coin_type === 'individual') {
      individual += received;
    } else if (balance.coin_type === 'organizational') {
      organizational += received;
    }
  });

  return {
    individualCoins: individual,
    organizationalCoins: organizational,
    totalCoins: individual + organizational,
    coinsSent: totalCoinsSent
  };
};

/**
 * Gets coin type display information
 * @param {string} coinType - 'individual' or 'organizational'
 * @returns {Object} Object containing display label and icon
 */
export const getCoinTypeInfo = (coinType) => {
  // Organization coins temporarily disabled - always show as Individual
  // const isIndividual = coinType === 'individual';
  return {
    label: 'Individual', // isIndividual ? 'Individual' : 'Organizational',
    icon: '$', // isIndividual ? '$' : '🏆',
    type: 'individual' // coinType
  };
};
